import { render, staticRenderFns } from "./SeckillSessionEdit.vue?vue&type=template&id=b8c3c4b2&scoped=true"
import script from "./SeckillSessionEdit.vue?vue&type=script&lang=js"
export * from "./SeckillSessionEdit.vue?vue&type=script&lang=js"
import style0 from "./SeckillSessionEdit.vue?vue&type=style&index=0&id=b8c3c4b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c3c4b2",
  null
  
)

export default component.exports